module.exports = __webpack_public_path__ + "img/deviceBorrow-mine-bar-1.f361043c.png";